<template>
  <div>    
    <div v-if="false" class="tree-container">
      <vue2-org-tree
        :data="treeData"
        :expand="true"
        :collapsable="true"
        :horizontal="false"
        labelWidth="100px"
        labelClassName="label-nowrap"
        @on-expand="expand"
        @on-node-click="nodeclick"
      ></vue2-org-tree>
    </div>
    <b-button @click="testDB">測試</b-button>
    <b-button @click="showModal = !showModal">工具</b-button>
    <!--<div id="summernote" ref="summernote" >Hello Summernote</div>-->
    <b-button @click="setView">純檢視</b-button>
    <b-button @click="setEdit">編輯</b-button>
    <!--<b-button @click="setImg">圖片插入</b-button>
    <b-button @click="setBtn">按鈕插入</b-button>
    <b-button @click="setRemove">移除模式</b-button>
    <b-button @click="saveOverlay">保存編輯結果</b-button>
    <b-button @click="loadOverlay">載入編輯結果</b-button>-->
    <image-overlay
      ref="imgOverlay"
      targetKey="SaveTwo"
      :backgroundImg="fileUrl"
      width="60vw"
      height="50vw"
      :overlayItems="btns"
      :stack="overlayDrillStack"
      @overlayStateSaved="saveOverlay"
      @linkToTarget="linkToTarget"
    ></image-overlay>
    <b-modal 
      v-model="showModal"
      size="lg"
      :hide-footer="true"
      title="圖片工具"
      style="height:500px;overflow-y:scroll;"
      @shown="resetTool"
    >
      <image-work
        ref="imgTool"
      ></image-work>
    </b-modal>
  </div>
</template>

<script>

import ImageWork from '../Common/ImageWork'
import ImageOverlay from '../Common/ImageOverlay'
//import Vue2OrgTree from 'vue2-org-tree'

export default {
  name: 'DevTest',
  components: {
    ImageWork,
    ImageOverlay,
    //Vue2OrgTree,
  },
  data: function () {
    return {
      overlayMaps:{},
      overlayDrillStack:[],
      treeData:{
        label:"大大",
        someprops:{aaa:1,bbb:true},
        expand:true,
        children:[
          {
            label:"小小"
          },
          {
            label:"小小"
          },
          {
            label:"小小"
          },
          {
            label:"小小"
          },
          {
            label:"小小"
          },
          {
            label:"小小"
          },
          {
            label:"小小"
          },
          {
            label:"小小"
          },
          {
            label:"小小"
          },
          {
            label:"小小"
          },
          {
            label:"小小"
          },
          {
            label:"小小"
          },
          {
            label:"小小"
          },
          {
            label:"小小"
          },
          {
            label:"小小",
            expand:false,
            children:[
              {
                label:"哇賊賊賊賊賊" 
              },
              {
                label:"哇賊賊賊賊賊" 
              },
              {
                label:"哇賊賊賊賊賊" 
              },
              {
                label:"哇賊賊賊賊賊" 
              },
              {
                label:"哇賊賊賊賊賊" 
              },
              {
                label:"哇賊賊賊賊賊" 
              },
              {
                label:"哇賊賊賊賊賊" 
              },
              {
                label:"哇賊賊賊賊賊" 
              },
              {
                label:"哇賊賊賊賊賊" 
              },
              {
                label:"哇賊賊賊賊賊" 
              },
              {
                label:"哇賊賊賊賊賊" 
              },
              {
                label:"哇賊賊賊賊賊" 
              },
              {
                label:"哇賊賊賊賊賊" 
              },
              {
                label:"哇賊賊賊賊賊" 
              },
              {
                label:"哇賊賊賊賊賊" 
              },
              {
                label:"哇賊賊賊賊賊" 
              },
            ]
          },
          {
            label:"小小"
          },
          {
            label:"小小"
          },
          {
            label:"小小"
          },
          {
            label:"小小"
          },
          {
            label:"小小"
          },
          {
            label:"小小"
          },
        ]
      },
      showModal:false,
      content:"",
      btns:[],
      fileUrl:"data:image/png;base64,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",
    }
  },
  methods: {
    testDB() {
      //測試restful模式的api串接,因為在slim配置的post與get的url不一樣需要參數做區別,多傳apiTarget
      //現況即使是get也需要apikey與apiclient否則不給call(加上短碼是隨機字串而非數字規則流水號,所以爬蟲基本上爬不到)
      let qryBody = {
        module:'dispatch_info',
        method:'3c0868',
        useGet:true,
        apiTarget:'rest'
      }
      this.$bus.apiCall(qryBody, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('api讀取失敗：'+data.msg)
            vm.loading = false
            return
          }
          // eslint-disable-next-line
          // append可用concat來寫,記得要assign回自己         
          vm.$bus.fnShowInfo(JSON.stringify(data))
      },this)
      return
      /*let qryBody = {
        module:'Sample',
        method:'sampleReturnMock',
        newapi:true,
      }
      this.$bus.apiCall(qryBody, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('api讀取失敗：'+data.msg)
            vm.loading = false
            return
          }
          // eslint-disable-next-line
          // append可用concat來寫,記得要assign回自己         
          vm.$bus.fnShowInfo(JSON.stringify(data))
      },this)*/
    },
    expand(evt) {
      evt.expand = !evt.expand
      console.log(evt)
    },
    nodeclick(evt,data) {
      console.log(data)
    },
    setImg() {
      this.$refs.imgOverlay.setMode('AddImg')
    },
    setBtn() {
      this.$refs.imgOverlay.setMode('AddBtn',{caption:'我是按鈕',btnHeight:60,cursor:'cell'})
    },
    setView() {
      this.$refs.imgOverlay.setMode('View')
    },
    setEdit() {
      this.$refs.imgOverlay.setMode('Edit')
    },
    setRemove() {
      // 透過組件傳遞點擊對象callback才能把btns移除
      this.$refs.imgOverlay.setMode('RemoveItem')
    },
    saveOverlay(overlayItem) {
      /*let obj = {
        id:'savedOne',
        backgroundImg:this.fileUrl,
        width:"60vw",
        height:"50vh",
        overlayItems:this.btns,
      }*/
      //window.localStorage.setItem('savedOne', JSON.stringify(obj))
      this.overlayMaps[overlayItem.id] = overlayItem
      this.$refs.imgOverlay.setMode('View')
    },
    loadOverlay() {
      let raw = window.localStorage.getItem('savedOne')
      let obj = JSON.parse(raw)
      this.fileUrl = obj.backgroundImg
      this.btns = obj.overlayItems
    },
    resetTool() {
      if (this.$refs.imgTool) {
        this.$refs.imgTool.reset()
      }
    },
    addOverlayButton(btn) {
      btn.cb = btn.type==='img'?this.imgClicked:this.btnClicked
      this.btns.push(btn)
    },
    updateOverlayItem(item) {
      for (let i=0;i<this.btns.length;i++) {
        if (this.btns[i].id && this.btns[i].id === item.id) {
          this.btns[i] = this.CpObj(item)
          return
        }
      }
    },
    removeOverlayItem(item) {
      // 先用id來判斷
      for (let i=0;i<this.btns.length;i++) {
        if (this.btns[i].id && this.btns[i].id === item.id) {
          this.$bus.fnShowConfirm('是否刪除？',() => {
            this.btns.splice(i,1)
            this.$bus.fnClosePopup()
            return
          }, () => {
            this.$bus.fnClosePopup()
            return 
          })
        }
      }
    },
    imgClicked(item) {
      alert('image clicked'+item.id)
    },
    btnClicked(item) {
      alert('button clicked'+item.id)
    },
    linkToTarget(targetKey) {
      // 有連結對象的key時 就替換裡面的資料
      if (this.overlayMaps.hasOwnProperty(targetKey)) {
        this.$refs.imgOverlay.resetView(this.overlayMaps[targetKey].id,this.overlayMaps[targetKey].backgroundImg,this.overlayMaps[targetKey].overlayItems)
      }
    }
  },
  computed: {
    
  },
  mounted () {
    // 是可以用(要include在public下的index.html裡的head)
    // 但bootstrap的css與js版本與核心版本衝突,link過去系統會掛掉
    // 另外經過實驗,不透過jq的方式,summernote()會不是方法不能呼叫＝＝
    let vm = this
    /*$("#summernote").summernote({
      height:250,
      onInit: function () {
        $("#summernote").summernote("code", vm.content)
      },
      onChange: function () {
        vm.$emit('update:content', $("#summernote").summernote('code'))
      }
    })*/
    // 先做實驗性質,應該從資料庫同步抓下來
    // 圖片工具是專案=>下面key-value的物件,每個key對應一個主底圖(與下面的連結圖片或按鈕們)
    // 圖片或按鈕可以用key作為指定連結的目標,正常情境是樹狀結構,但不排斥重複使用的共用節點
    // 當然也不限制只能圖連結到別的圖,也可以直接切換到別的功能或跳popup(自訂callback)
    for (let key in window.localStorage) {
      if (key.startsWith('IOL_')  ) {
        this.overlayMaps[JSON.parse(window.localStorage.getItem(key)).id] = JSON.parse(window.localStorage.getItem(key))
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.tree-container {
  width:250px;
  height:500px;
  overflow: scroll;
}
::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 7px;
}
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: rgba(0, 0, 0, .5);
  -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, .5);
}
</style>
<style>
/*提供給org-tree的class不能scoped*/
.label-nowrap {
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
}
</style>